import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getClientDomain, getToken, translate, getPropertyPackagesStatus, getPackageTypeInfo, getPackageDetailStatusLabel } from '../../../../utils/Common';
import AuthContext from '../../../../contexts/auth';
import ModalContext from '../../../../contexts/modal';
import PageContainer from '../../../../components/layout/PageContainer/PageContainer';
import PageHeader from '../../../../components/layout/PageHeader/PageHeader';
import ContentCard from '../../../../components/layout/ContentCard/ContentCard';
import Button from '../../../../components/common/Button/Button';
import Badge from '../../../../components/common/Badge/Badge';
import Tabs from '../../../../components/common/Tabs/Tabs';
import * as FaIcons from 'react-icons/fa';
import { FaBox, FaTruckLoading, FaKey } from 'react-icons/fa';
import { PiLockersFill } from 'react-icons/pi';
import PackageOptionPanel from './PackageOptionPanel';
import PackageInfo from './PackageInfo';
import TableEstatusBoxit from './TableEstatusBoxit';
import TableEstatusProveedor from './TableEstatusProveedor';
import TableFacturacionProveedor from './TableFacturacionProveedor';
import { verifyAccessViewPermissions } from '../../../../config/permissions';
import styles from './PackageDetail.module.css';
import './index.css';

const PackageDetails = (props) => {
    const location = useLocation();
    const userContext = useContext(AuthContext);
    const modalContext = useContext(ModalContext);
    const [openModalChangeClient, setOpenModalChangeClient] = useState(false);
    const [idPaquete, setIdPaquete] = useState(props.selectedPackage?.IdPaquete);
    useEffect(() => {
        if (props.selectedPackage?.IdPaquete != null) {
            setIdPaquete(props.selectedPackage.IdPaquete);
        }
    }, [props.selectedPackage?.IdPaquete]);
    const [optionSelected, setOptionSelected] = useState("");
    const [updateComponent, setUpdateComponent] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const onClickPanelOption = (value) => {
        setOptionSelected(value);
    };

    const getInfoPaquete = async (data) => {
        try {
            setUpdateComponent(!updateComponent);
            modalContext.setIsOpenModal(false);
            const dataToSend = {
                IdUsuario: data.IdUsuario,
                numeroPaquete: data.Nro_Id,
            };
            const response = await fetch(`${getClientDomain(2)}/dashboard/packages/find/tracking`, {
                method: 'POST',
                connection: 'keep-alive',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify(dataToSend)
            });
            const result = await response.json();
            if (result.code === 200 && result.payload?.length > 0 && result.payload[0]) {
                props.handleSelectedPackage(result.payload[0]);
                if (props.packagesFound && Array.isArray(props.packagesFound)) {
                    const index = props.packagesFound.findIndex(obj => obj.IdPaquete === props.selectedPackage.IdPaquete);
                    if (index >= 0) props.packagesFound[index] = result.payload[0];
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        const handleResize = () => window.innerWidth < 1500 ? setIsMobile(true) : setIsMobile(false);
        if (window.innerWidth < 1536) setIsMobile(true);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleOpenModalChangeClient = () => {
        setOpenModalChangeClient(!openModalChangeClient);
    };

    const handleCancelBusqueda = props.handleCancelBusqueda;
    const handleBreadcrumbClick = (e) => {
        e.preventDefault();
        handleCancelBusqueda();
    };

    const pkg = props.selectedPackage;
    if (!pkg) {
        return null;
    }
    const statusInfo = pkg?.IdEstatus != null ? getPropertyPackagesStatus(pkg.IdEstatus) : null;
    const typeInfo = pkg ? getPackageTypeInfo(pkg) : null;
    const showOptions = ((pkg?.IdEstatus !== 4 && pkg?.IdEstatus !== 6 && pkg?.IdEstatus !== 3) || (pkg?.IdEstatus !== 4 && pkg?.IdEstatus !== 6)) && verifyAccessViewPermissions(["read-actions"], { path: location.pathname });
    const isAdminWithTables = userContext.user?.IdUsuario === 8 && userContext.user?.IsAdmin;

    const headerSubtitle = (
        <div className={styles.pkgHeader}>
            <div className={styles.pkgHeaderStatusRow} aria-label="Package status">
                {statusInfo && (
                    <span
                        className={styles.statusPill}
                        style={{
                            color: statusInfo.color || '#111827',
                            backgroundColor: 'transparent',
                            borderColor: statusInfo.color || 'currentColor',
                        }}
                    >
                        {statusInfo.icon && <span className={styles.infoIcon}>{statusInfo.icon}</span>}
                        <span>{getPackageDetailStatusLabel(pkg.IdEstatus, pkg.IdTipoPaquete)}</span>
                    </span>
                )}

                {typeInfo && (
                    <span
                        className={styles.statusPill}
                        style={{
                            color: typeInfo.color || '#111827',
                            backgroundColor: typeInfo.bg || 'rgba(0,0,0,0.03)',
                            borderColor: 'transparent',
                        }}
                    >
                        {typeInfo.icon && <span className={styles.infoIcon}>{typeInfo.icon}</span>}
                        <span>{typeInfo.text ? translate(typeInfo.text) : ''}</span>
                    </span>
                )}
            </div>

            <div className={styles.pkgHeaderMetaRow} aria-label="Package metadata">
                <div className={styles.metaItem}>
                    <FaKey size={14} className={styles.metaIcon} />
                    <span className={styles.metaLabel}>ID Boxit:</span>
                    <span className={styles.metaValue}>{pkg?.IdPaquete ?? '—'}</span>
                </div>
                <div className={styles.metaItem}>
                    <FaBox size={14} className={styles.metaIcon} />
                    <span className={styles.metaLabel}>{translate('global.numPackage')}:</span>
                    <span className={styles.metaValue}>{pkg?.Nro_Id ?? '—'}</span>
                </div>
                <div className={styles.metaItem}>
                    <FaTruckLoading size={14} className={styles.metaIcon} />
                    <span className={styles.metaLabel}>{translate('dashboard.packages.details.numTracking')}:</span>
                    <span className={styles.metaValue}>{pkg?.NumeroTracking ?? '—'}</span>
                </div>
                <div className={styles.metaItem}>
                    <PiLockersFill size={14} className={styles.metaIcon} />
                    <span className={styles.metaLabel}>{translate('global.locker')}:</span>
                    <span className={styles.metaValue}>{pkg?.Plataforma ?? '—'}</span>
                </div>
            </div>
        </div>
    );

    const overviewContent = (
        <div className={styles.overviewContainer}>
            <div className={styles.overviewLayout}>
                {showOptions && (
                    <aside className={styles.overviewSidebar} aria-label={translate("dashboard.packages.details.optionPanel.title")}>
                        <PackageOptionPanel
                            selectedPackage={pkg}
                            optionSelected={optionSelected}
                            onClickPanelOption={onClickPanelOption}
                            handleCancelBusqueda={handleCancelBusqueda}
                            getInfoPaquete={getInfoPaquete}
                            isMobile={isMobile}
                            handleOpenModalChangeClient={handleOpenModalChangeClient}
                        />
                    </aside>
                )}
                <div className={styles.overviewContent}>
                    <PackageInfo
                        selectedPackage={pkg}
                        handleSelectedPackage={props.handleSelectedPackage}
                        optionSelected={optionSelected}
                        onClickPanelOption={onClickPanelOption}
                        getInfoPaquete={getInfoPaquete}
                        isOpenModalChangeClient={openModalChangeClient}
                        handleOpenModalChangeClient={handleOpenModalChangeClient}
                    />
                </div>
            </div>
        </div>
    );

    const tabs = [
        {
            label: translate('dashboard.packages.details.tabs.information'),
            icon: <FaBox size={18} />,
            component: overviewContent,
            show: true,
        },
        {
            label: translate('dashboard.packages.details.tabs.tracking'),
            icon: <FaIcons.FaListAlt size={18} />,
            component: (
                <TableEstatusBoxit idPaquete={idPaquete} updateComponent={updateComponent} />
            ),
            show: true,
        },
        {
            label: translate('dashboard.packages.details.tableStatusBoxit.statusProvider'),
            icon: <FaIcons.FaTruck size={18} />,
            component: (
                <ContentCard
                    title={translate('dashboard.packages.details.tableStatusBoxit.statusProvider')}
                    padding="md"
                >
                    <TableEstatusProveedor idPaquete={idPaquete} updateComponent={updateComponent} />
                </ContentCard>
            ),
            show: !!isAdminWithTables,
        },
        {
            label: translate('dashboard.packages.details.tableStatusBoxit.title'),
            icon: <FaIcons.FaFileInvoiceDollar size={18} />,
            component: (
                <ContentCard
                    title={translate('dashboard.packages.details.tableStatusBoxit.title')}
                    padding="md"
                >
                    <TableFacturacionProveedor idPaquete={idPaquete} updateComponent={updateComponent} />
                </ContentCard>
            ),
            show: !!isAdminWithTables,
        },
    ].filter(t => t.show);

    return (
        <PageContainer>
            <PageHeader
                title={pkg?.Nro_Id || translate('dashboard.packages.details.infoPackage')}
                subtitle={headerSubtitle}
                breadcrumbs={[
                    (
                        <span
                            key="packages"
                            onClick={handleBreadcrumbClick}
                            className={styles.breadcrumbLink}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleBreadcrumbClick(e); } }}
                        >
                            {translate('global.packageSearch')}
                        </span>
                    ),
                    translate('global.detail')
                ]}
                icon={<FaBox size={24} />}
                actions={
                    <div className={styles.headerActions}>
                        <Button
                            variant="primary"
                            onClick={handleBreadcrumbClick}
                            leftIcon={<FaIcons.FaArrowLeft />}
                        >
                            {translate('dashboard.packages.details.actions.backToPackages')}
                        </Button>
                    </div>
                }
                divider={false}
            />
            <Tabs
                items={tabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                lazy={false}
            />
        </PageContainer>
    );
};

export default PackageDetails;
